import axios from 'axios';
import { useUserSession } from '@/stores/userSession';

// Deliberately does NOT use useAxios() here: this is called from the router
// guard (routerGuard.ts), including on the very first, synchronous navigation
// that fires during app.use(router) — before Vue's injection context (and the
// axiosPlugin provider) exists. useAxios() relies on inject(), which throws
// "can only be used inside setup()" in that situation. Pinia stores don't have
// that restriction, so we read the token directly and post with plain axios,
// mirroring useAxios.ts's own request setup (base URL + Authorization header).
export function useModuleAccessApi() {
    function ping(module: string): Promise<void> {
        const userSession = useUserSession();
        if (!userSession.token) {
            return Promise.resolve();
        }
        return axios
            .post(
                `${import.meta.env.VITE_API_BASE_URL}/module-access/ping`,
                { module },
                { headers: { Authorization: userSession.token } }
            )
            .then(() => undefined);
    }

    return {
        ping,
    };
}
